// @core/api/endpoints/search/delete_search_index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/search';

/**
 * Delete search index
 * Deletes a search index and all associated indexed documents.
 */
export async function DeleteSearchIndex(
  index_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/indexes/:index_id`;
  requestPath = requestPath.replace(':index_id', encodeURIComponent(index_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
